import { useTranslation } from "react-i18next";
import { useRenewalOverview } from "../interfaces/Renwals";
import { importStatusToString, isImported, renewalNoticeStatusToString } from "../state/modern_states";
import { Link } from "src/navigation";
import clsx from "clsx";
import { IconEdit, IconSpinner } from "src/components/icons";
import { paymentHandlingAction, renewalHandlingActionName } from "../import";
import { useSettings } from "../interfaces/Settings";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

export type RenewalImplementation = 'none' | 'dennemeyer' | 'dummy' | 'patent-renewal'
const implementationNames = {
    dennemeyer: 'Dennemeyer',
    ['patent-renewal']: 'Patent Renewal',
}

export function MemberOverview() {
    const {t} = useTranslation()
    const {implementation} = useSettings()
    const { ipRight, renewals, ipRightImportStatus, renewalsStatus } = useRenewalOverview()

    const canHaveHistory = renewals.length > 0

    return <>
        {implementation in implementationNames && <div className="-mt-3 col-start-2 justify-self-end text-right, text-slate-300 text-xs">{implementationNames[implementation]}</div>}
        <div className={labelStyle} onClick={() => console.log({ipRight, renewals, ipRightImportStatus, renewalsStatus})}>
            {t('renewals-status')}
        </div>
        <div className={valueStyle}><RenewalStatusValue /></div>

        {canHaveHistory && <>
            <div className={labelStyle}>{t('history')}</div>
            <div className={valueStyle}><HistoryLink /*{...{maintenanceActionStatus, params}}*/ /></div>
        </>}

    </>
}

const labelStyle = "sm:text-right text-gray-500 whitespace-nowrap"
const valueStyle = "max-sm:pl-4"

// TODO: fix paths
function RenewalStatusValue() {
    const {t} = useTranslation()

    const { implementation } = useSettings()
    const { ipRightImportStatus, renewalsStatus, isLoading } = useRenewalOverview()

    const isNotHandled = ipRightImportStatus.status === 'not-handled' || ipRightImportStatus.substatus === 'back-office-processing'

    const imported = isImported(ipRightImportStatus)
    const action = paymentHandlingAction({status: ipRightImportStatus, imported})

    const isEdit = action === 'edit'

    // console.log({ipRightImportStatus, renewalsStatus, renewals})

    const commonLabelStyle = "ml-2 text-xs px-2 py-1 whitespace-nowrap rounded-full"

    const label = 
        ipRightImportStatus.inReview
        ? <span className={clsx(commonLabelStyle, "bg-indigo-500 text-indigo-50")} title={t('in-pending-review-help')}><ExclamationTriangleIcon className="size-4" /></span>
        : ipRightImportStatus.inSurcharge
        ? <span className={clsx(commonLabelStyle, "bg-amber-500 text-amber-50")} title={t('in-surcharge-help')}>{t('in-surcharge')}</span>
        : null

    return (
        <div className="flex flex-row w-full gap-2 justify-between">
            {(isNotHandled || renewalsStatus.id === undefined)
                ? <div>
                    {importStatusToString(ipRightImportStatus, t)} {isLoading && <IconSpinner className="h-3 w-3 mb-1 inline animate-spin text-pcx-600" />}
                    {label}
                </div>
                : <span>
                    <Link className="underline-link" to={`_renewals/instruct/${renewalsStatus.id}`}>
                        {renewalNoticeStatusToString(renewalsStatus, t)} 
                    </Link>
                    {label}
                </span>}

            <Link title={`${t('renewals')}: ${action}`}
                to={{ pathname: `_renewals/import/${implementation}` }}
                className={clsx("btn-secondary text-sm self-start whitespace-nowrap", isEdit ? "p-px" : "py-px")}
            >
                {isEdit
                    ? <IconEdit className="size-4" />
                    : t(renewalHandlingActionName(action))}
            </Link>
        </div>
    )
}

function HistoryLink() {
    const {t} = useTranslation()
    const { renewalsStatus } = useRenewalOverview()

    if (renewalsStatus.status === 'ready') {
        return <span>{t('no-history')}</span>
    }

    return (
        <Link
            to={{ pathname: "_renewals/history" }}
            className="underline-link pl-0 sm:pl-0"
        >
            {t('ma.instructions', { count: renewalsStatus.total })}
        </Link>
    )
}